import { createAsyncThunk } from "@reduxjs/toolkit";
import { apiConnector } from "../apiConnector";
import { endpoint } from "../apis";
import Cookies from "js-cookie";
import { toast } from "react-toastify";

// Async Thunk for Ad Placement Details
export const adPlacementDetailsHandler = createAsyncThunk(
  "adPlacementDetails/action",
  async ({ actionType, data,showToast = true}, { rejectWithValue }) => {
    try {
      const token = Cookies.get("authToken");
      let payload;

      switch (actionType) {
        case "list":
          payload = {
            action: "list",
            campaign_id: data.campaign_id,
          };
          break;

        case "create":
        case "update":
          payload = {
            action: actionType,
            campaign_id: data.campaign_id,
            in_content_ad_placements: data.in_content_ad_placements,
            content_data: data.content_data
          };
          break;

        default:
          return rejectWithValue("Invalid action type");
      }

      const response = await apiConnector(
        "post",
        endpoint.AD_PLACEMENT_DETAILS,
        payload,
        { Authorization: `Bearer ${token}` }
      );

      if (response.data.Response) {
        if (showToast) {
          toast.success(`Successfully ${actionType}ed ad placement details`);
        }
        return response.data.Response;
      } else {
        return rejectWithValue("Unexpected response format");
      }
    } catch (error) {
      console.error("API Error:", error);
      toast.error(error.response?.data?.message || "Operation failed");
      return rejectWithValue(error.response?.data || "API request failed");
    }
  }
);